import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bb9bf25e")

_pushScopeId("data-v-bb9bf25e")
const _hoisted_1 = { class: "d-flex justify-content-center align-items-center align-content-center root" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "big-number" }
const _hoisted_4 = { class: "unit text-muted" }
_popScopeId()


    
export default _defineComponent({
  props: {
        value: Number,
        unit: String,
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(__props.value), 1),
      _createVNode("div", _hoisted_4, _toDisplayString(__props.unit), 1)
    ])
  ]))
}
}

})